import { Component, Inject, OnInit, HostListener } from '@angular/core';
import {
  FormBuilder,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MessageBoxComponent,
  MessageBoxParameters,
  MessageBoxType,
} from 'app/components/messageBox/messageBox.component';
import { Retention } from 'app/shared/models/retention';
import { Subject } from 'app/shared/models/subject';
import { DataFieldService } from 'app/shared/services/data-field.service';
import { RetentionService } from 'app/shared/services/retention.service';
import { ValidationErrorsComponent } from 'app/components/validation-errors/validation-errors.component';

@Component({
  selector: 'app-retention-prompt',
  templateUrl: './retention-prompt.component.html',
  styleUrls: ['./retention-prompt.component.scss'],
})
export class RetentionPromptComponent implements OnInit {
  // listOfRetentions: Retention[];
  form: UntypedFormGroup;
  daysToAdd: number;
  oldRetentionId: number = null;
  oldRetentionDays: number = null;
  retentionAlreadySet: boolean = false;
  allowCancel: boolean = true;

  showApplyTo: boolean = true;
  applyTo: number = 2;

  constructor(
    public dialogRef: MatDialogRef<RetentionPromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public retentionService: RetentionService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (this.data) {
      if (this.data.allowCancel != undefined)
        this.allowCancel = this.data.allowCancel;

      if (this.data.showApplyTo != undefined)
        this.showApplyTo = this.data.showApplyTo;
    }

    if (this.data.returnIfSet === true && this.data.subject && this.data.subject.retentionId && this.data.subject.retentionData) {
      this.dialogRef.close({ data: this.data.subject });
      return;
    }

    var retentionId: number = undefined;
    if (this.data?.subject?.retentionId > 0)
      retentionId = this.data?.subject?.retentionId;
    
    if (this.data?.subject)      
      this.showApplyTo = false;
    else
        this.showApplyTo = true;

        this.form = this.fb.group({
      retentionPeriod: [retentionId, Validators.required],
      applyTo: [this.applyTo],
    });

    if (this.allowCancel == false) {
      this.dialogRef.disableClose = true;
    }

    if (this.data?.subject?.retentionId) {
      this.oldRetentionId = this.data.subject.retentionId;
      this.oldRetentionDays = this.retentionService.listOfRetentions.filter(
        (i) => i.id === this.oldRetentionId
      )[0].retentionDays;
    }
  }

  public confirmSubmit() {
    if (this.oldRetentionId != null) {
      const info = new MessageBoxParameters(
        'This will reset the retention date for this case, are you sure?',
        'Confirm',
        MessageBoxType.YesNo,
        true
      );
      this.dialog
        .open(MessageBoxComponent, {
          data: info,
          disableClose: false,
          autoFocus: false,
        })
        .afterClosed()
        .subscribe((result) => {
          if (result === 'yes') {
            this.saveChanges();
          }
        });
    } else this.saveChanges();
  }

  saveChanges() {
    let retention: Retention = this.retentionService.listOfRetentions.find(
      (i) => i.id == this.form.controls['retentionPeriod'].value
    );
    // No Retention selected, so close the dialog with no results
    if (!retention)
      this.dialogRef.close(null);

    // No Subject selected, so close the dialog with the selected retention.
    if (!this.data.subject) {
      this.dialogRef.close({ retention: retention, applyTo: this.form.controls['applyTo'].value });
      return;
    }

    // Apply new retention to specified subject
    this.data.subject = this.retentionService.ApplyRetentionToSubject(retention, this.data.subject);

    // return updated subject
    this.dialogRef.close({ data: this.data.subject });
  }
}
